// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"243":"recruitment","809":"users","983":"products"}[chunkId] + "." + {"243":"d35abcac","809":"3a176001","983":"f5e32843"}[chunkId] + ".js";
};